export default __webpack_public_path__ + "static/media/trash-icon.8329f97f.svg";